import { jsx as _jsx } from "react/jsx-runtime";
import { ListItemIcon, makeStyles, Tooltip } from '@material-ui/core';
import clsx from 'clsx';
import { transitionSpeed } from '../../../../theme';
const useStyles = makeStyles((theme) => ({
    navIcon: {
        color: '#9e9e9e',
        display: 'flex',
        justifyContent: 'center',
        marginRight: theme.spacing(1),
        minWidth: 24,
        transition: `color ${transitionSpeed} ease-out`,
    },
    navIconCollapsedOpen: {
        color: '#424242',
    },
    tooltip: {
        visibility: 'hidden',
    },
    tooltipCollapsed: {
        visibility: 'visible',
    },
}));
/**
 * Icon component for the `LeftNavLink` component.
 *
 * @param icon - The icon to be displayed.
 * @param isCollapsed - Indicates whether the sub link panel is collapsed.
 * @param isMenuOpen - Indicates whether the left navigation is open.
 * @param text - The tooltip text to be displayed.
 * @returns The rendered `Icon` component.
 */
export function Icon({ icon, isCollapsed, isMenuOpen, text }) {
    const classes = useStyles();
    return (_jsx(Tooltip, { arrow: true, placement: 'right', title: text, classes: {
            tooltip: clsx(classes.tooltip, {
                [classes.tooltipCollapsed]: !isMenuOpen,
                [classes.navIconCollapsedOpen]: isCollapsed,
            }),
        }, children: _jsx(ListItemIcon, { className: classes.navIcon, "data-testid": 'icon', children: icon }) }));
}
